// Pure helpers for PricingContractSummary estimate payload building.
// Extracted from PricingContractSummary.jsx buildPayload so the transformation
// can be unit-tested in isolation.

// Builds the `miscellaneousitems` payload sent to SaveEstimatesDiscount.
// All inputs are the component's props/state; the function is side-effect free.
export function buildEstimatePayload({
  selectedSundries,
  sundriesLineEstimate,
  selectedLaborSundries,
  sundriesKitLineEstimate,
  selectedMaterialSundries,
  selectedLabor,
  laborLineEstimate,
  storeId,
  sundriesDisplayInSummary,
  laborDisplayInSummary,
}) {
  const sundriesItems = (selectedSundries || [])
    .filter((_, index) => sundriesLineEstimate[index] ?? false)
    .map((item) => ({
      // kitId is a non-0able Int32 on the API model; a kit-less line item
      // must send 0, never 0 (matches estimateTable.jsx convention).
      kitId: item.kitId || 0,
      productId: item.productId || 0,
      materialId: item.materialId || 0,
      storeId: item.storeId || storeId || 0,
      materialPricingId: item.materialPricingId || 0,
      pricingContractId: item.pricingContractId || 0,
    }));

  const sundriesLaborKitItems = (selectedLaborSundries || [])
    .filter((item) => item.kitId && (sundriesKitLineEstimate[item.kitId] ?? false))
    .map((item) => ({
      kitId: item.kitId || 0,
      laborId: item.laborId || 0,
      laborItemId: item.laborItemId || 0,
      laborPricingId: item.laborPricingId || 0,
      storeId: item.storeId || storeId || 0,
    }));

  const sundriesMaterialKitItems = (selectedMaterialSundries || [])
    .filter((item) => item.kitId && (sundriesKitLineEstimate[item.kitId] ?? false))
    .map((item) => ({
      kitId: item.kitId || 0,
      materialId: item.materialId || 0,
      storeId: item.storeId || storeId || 0,
      materialPricingId: item.materialPricingId || 0,
    }));

  const laborItems = (selectedLabor || [])
    .filter((_, index) => laborLineEstimate[index] ?? false)
    .map((item) => ({
      // kitId is a non-0able Int32 on the API model; a kit-less line item
      // must send 0, never 0 (matches estimateTable.jsx convention).
      kitId: item.kitId || 0,
      laborId: item.laborId || 0,
      laborItemId: item.laborItemId || 0,
      storeId: item.storeId || storeId || 0,
      laborPricingId: item.laborPricingId || 0,
    }));

  return {
    sundries: {
      displayInEstimateSummary: sundriesDisplayInSummary,
      items: sundriesItems,
      laborKitItems: sundriesLaborKitItems,
      materialKitItems: sundriesMaterialKitItems,
    },
    labor: {
      displayInEstimateSummary: laborDisplayInSummary,
      items: laborItems,
    },
  };
}
